<div class="paginate">
  <span *ngIf="current > 1">
    <i class="fa fa-angle-left fa-2x" (click)="previousPage()" alt=""></i>
  </span>
  <span
    *ngFor="let item of listItem"
    [ngStyle]="{ backgroundColor: item === current ? '#007bff' : '' }"
    (click)="choosePage(item)"
  >
    {{ item }}
  </span>
  <span *ngIf="current < pagination.lastPage">
    <i class="fa fa-angle-right fa-2x" (click)="nextPage()" alt=""></i>
  </span>
</div>
